import _ from 'lodash';
import * as formatter from '../../_config/formatter';
import * as GatewayAPI from '../../_config/gatewayAPI';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { EXPORT_FORMATS } from '../../_config/consts';
import * as ModalActions from './modal.actions';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import moment from 'moment';
import {
  APPEND_GATEWAYS,
  APPEND_WIRED_GATEWAYS,
  REMOVE_GATEWAY,
  RESET_GATEWAYS_DATA,
  RESET_GATEWAYS_FILTERS,
  RESET_GATEWAYS_PAGINATION_DATA,
  RESET_WIRED_GATEWAYS_DATA,
  RESET_WIRED_GATEWAYS_FILTERS,
  SAVE_GATEWAYS,
  SAVE_GATEWAYS_PAGINATION,
  SAVE_WIRED_GATEWAYS,
  SAVE_WIRED_GATEWAYS_PAGINATION,
  SET_GATEWAYS_FILTER,
  SET_GATEWAYS_OPERATIONAL_MODE,
  SET_SELECTED_GATEWAY,
  SET_SELECTED_GATEWAY_NOTIFICATION,
  SET_SELECTED_WIRED_GATEWAY,
  SET_WIRED_GATEWAYS_FILTER,
  UPDATE_GATEWAY,
  UPDATE_WIRED_GATEWAY,
  SET_GATEWAYS_ORDER,
  SAVE_HYPERTOUCH_DEVICES,
  SET_SELECTED_HYPERTOUCH_DEVICE,
  SET_HYPERTOUCH_DEVICES_OPERATIONAL_MODE,
} from './actionTypes/gateways';
import * as UserActions from './user.actions';

function formatGatewayWithSmartLocks(gateway) {
  return {
    ...gateway,
    smartLocks: _.map(gateway.smartLocks || [], lock =>
      formatter.formatInputData(formatter.LOCK, lock)
    ),
  };
}

export function saveGateways(gateways) {
  return {
    type: SAVE_GATEWAYS,
    gateways,
  };
}

export function appendGateways(gateways) {
  return {
    type: APPEND_GATEWAYS,
    gateways,
  };
}

export function saveGatewaysPagination(pagination) {
  return {
    type: SAVE_GATEWAYS_PAGINATION,
    pagination,
  };
}

export function setGatewaysFilter(field, value) {
  return {
    type: SET_GATEWAYS_FILTER,
    field,
    value,
  };
}

export function setOrder(orderBy, orderDir) {
  return {
    type: SET_GATEWAYS_ORDER,
    orderBy,
    orderDir,
  };
}

export function setSelectedGateway(gateway) {
  return {
    type: SET_SELECTED_GATEWAY,
    gateway,
  };
}

export function updateGatewayInState(gateway) {
  return {
    type: UPDATE_GATEWAY,
    gateway,
  };
}

export function removeGatewayFromState(gatewayId) {
  return {
    type: REMOVE_GATEWAY,
    gatewayId,
  };
}

export function resetGatewaysData() {
  return {
    type: RESET_GATEWAYS_DATA,
  };
}

export function resetGatewaysFilters() {
  return {
    type: RESET_GATEWAYS_FILTERS,
  };
}

export function setOperationalMode(value) {
  return {
    type: SET_GATEWAYS_OPERATIONAL_MODE,
    value,
  };
}

export function saveWiredGateways(gateways) {
  return {
    type: SAVE_WIRED_GATEWAYS,
    gateways,
  };
}

export function resetGatewaysPaginationData() {
  return {
    type: RESET_GATEWAYS_PAGINATION_DATA,
  };
}

export function appendWiredGateways(gateways) {
  return {
    type: APPEND_WIRED_GATEWAYS,
    gateways,
  };
}

export function saveWiredGatewaysPagination(pagination) {
  return {
    type: SAVE_WIRED_GATEWAYS_PAGINATION,
    pagination,
  };
}

export function setSelectedWiredGateway(gateway) {
  return {
    type: SET_SELECTED_WIRED_GATEWAY,
    gateway,
  };
}

export function resetWiredGatewaysData() {
  return {
    type: RESET_WIRED_GATEWAYS_DATA,
  };
}

export function setWiredGatewaysFilter(field, value) {
  return {
    type: SET_WIRED_GATEWAYS_FILTER,
    field,
    value,
  };
}

export function resetWiredGatewayFilters() {
  return {
    type: RESET_WIRED_GATEWAYS_FILTERS,
  };
}

export function updateWiredGatewayInState(gateway) {
  return {
    type: UPDATE_WIRED_GATEWAY,
    gateway,
  };
}

export function setSelectedHyperTouchDevice(device) {
  return {
    type: SET_SELECTED_HYPERTOUCH_DEVICE,
    device,
  };
}

export function setHyperTouchDevicesOperationalMode(value) {
  return {
    type: SET_HYPERTOUCH_DEVICES_OPERATIONAL_MODE,
    value,
  };
}

export function fetchGateways(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { data: { filters } } } = getState();
      const params = {
        ...filters,
        page,
        pageSize,
      };
      const response = await GatewayAPI.fetchGateways(params);
      if (response && response.data && response.data.content) {
        dispatch(saveGateways(response.data.content));
        dispatch(saveGatewaysPagination(_.omit(response.data, 'content')));
        return response.data.content;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function fetchGatewaysWithDetails(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { data: { filters } } } = getState();
      const orderBy = getState().gateways.data.sorting.orderBy;
      const orderDir = orderBy?getState().gateways.data.sorting.orderDir:undefined;
      const params = {
        ...filters,
        page,
        pageSize,
        orderBy,
        orderDir,
        withSmartLocks: true,
      };
      const response = await GatewayAPI.fetchGateways(params);
      if (response && response.data && response.data.content) {
        const formattedGateways = _.map(response.data.content, formatGatewayWithSmartLocks);
        dispatch(saveGateways(formattedGateways));
        dispatch(saveGatewaysPagination(_.omit(response.data, 'content')));
        return formattedGateways;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function fetchAndAppendGatewaysWithDetails(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { data: { filters } } } = getState();
      const orderBy = getState().gateways.data.sorting.orderBy;
      const orderDir = orderBy ? getState().gateways.data.sorting.orderDir : undefined;
      const params = {
        ...filters,
        page,
        pageSize,
        orderBy,
        orderDir,
        withSmartLocks: true,
      };
      const response = await GatewayAPI.fetchGateways(params);
      if (response && response.data && response.data.content) {
        const formattedGateways = _.map(response.data.content, formatGatewayWithSmartLocks);
        dispatch(appendGateways(formattedGateways));
        dispatch(saveGatewaysPagination(_.omit(response.data, 'content')));
        return formattedGateways;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function fetchAndAppendGateways(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { data: { filters } } } = getState();
      const params = {
        ...filters,
        page,
        pageSize,
      };
      const response = await GatewayAPI.fetchGateways(params);
      if (response && response.data && response.data.content) {
        dispatch(appendGateways(response.data.content));
        dispatch(saveGatewaysPagination(_.omit(response.data, 'content')));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function createGateway(gatewayDTO) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.createGateway(gatewayDTO);
      if (response.data) {
        dispatch(updateGatewayInState(response.data));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function deleteGateway(gatewayId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.deleteGateway(gatewayId);
      if (response.data) {
        dispatch(removeGatewayFromState(gatewayId));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function addLockToGateway(gatewayId, lockId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.addLockToGateway(gatewayId, lockId);
      if (response.data) {
        dispatch(updateGatewayInState(response.data));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function getGatewaysSmartLocks(gatewayId) {
  return async (dispatch, getState) => {
    try {
      const filters = {
        page: 0,
        pageSize: 100, // FIXME
        gatewayId,
      };
      const response = await GatewayAPI.fetchGatewaySmartlocks(filters);
      if (response.data && response.data.content) {
        const formattedLocks = _.map(response.data.content, lock => formatter.formatInputData(formatter.LOCK, lock));
        return formattedLocks;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function getGatewayDetails(gatewayId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.fetchGatewayDetails(gatewayId);
      if (response.data) {
        let gatewayDetailed = response.data;
        gatewayDetailed = formatGatewayWithSmartLocks(gatewayDetailed);
        dispatch(updateGatewayInState(gatewayDetailed));
        return gatewayDetailed;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function editGatewayDetails(gatewayId, editDTO) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.editGatewayDetails(gatewayId, editDTO);
      if (response.data) {
        const gatewayDetailed = await dispatch(getGatewayDetails(gatewayId));
        return gatewayDetailed;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function sendGatewayNotification(gatewayId, payload) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.sendGatewayNotification(gatewayId, payload);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function openSmartLockHyperGateHighFlex(gatewayId, payload) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.openHighFlexGatewaySmartLock(gatewayId, payload);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function togglePassageModeSmartLockHyperGateHighFlex(gatewayId, payload) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.togglePassageModeSmartLockHyperGateHighFlex(gatewayId, payload);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function getGatewayNotificationDetails(gatewayId, notificationId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.fetchGatewayNotification(gatewayId, notificationId);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function setSelectedGatewayNotification(notification) {
  return {
    type: SET_SELECTED_GATEWAY_NOTIFICATION,
    notification,
  };
}

export function fetchAtlasGateways(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { wired: { filters } } } = getState();
      const params = {
        ...filters,
        page,
        pageSize,
      };
      const response = await GatewayAPI.fetchAtlasGateways(params);
      if (response && response.data && response.data) {
        const atlasGatewaysData = _.filter(response.data, atlas => atlas.initialized);
        dispatch(saveWiredGateways(atlasGatewaysData));
        return response.data.content;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function systemHasAtlas() {
  return async (dispatch, getState) => {
    try {
      const params = {
        page: 0,
        pageSize: 1,
      };
      const response = await GatewayAPI.fetchAtlasGateways(params);
      if (response && response.data) {
        dispatch(UserActions.systemHasAtlasGateways(!_.isEmpty(response.data)));
        return response.data.content;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}
export function fetchAndAppendAtlasGateways(page = 0, pageSize = 50) {
  return async (dispatch, getState) => {
    try {
      const { gateways: { wired: { filters } } } = getState();
      const params = {
        ...filters,
        page,
        pageSize,
      };
      const response = await GatewayAPI.fetchAtlasGateways(params);
      if (response && response.data) {
        const atlasGatewaysData = _.filter(response.data, atlas => atlas.initialized);
        dispatch(appendWiredGateways(atlasGatewaysData));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function getAtlasGatewayDetails(gatewayId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.fetchAtlasGatewayDetails(gatewayId);
      if (response.data) {
        const gatewayDetailed = response.data;
        dispatch(updateWiredGatewayInState(gatewayDetailed));
        return gatewayDetailed;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function exportGateways(format = EXPORT_FORMATS.CSV) {
  return async (dispatch, getState) => {
    try {
      const gateways = await dispatch(fetchGatewaysWithDetails());
      const exportData = [];
      _.each(gateways, (gateway) => {
        exportData.push({
          ID: gateway.id,
          Name: gateway.name,
          'Device ID': gateway.deviceId,
          [L20NContext.getSync('deviceType')]: gateway.deviceType,
          [L20NContext.getSync('firmwareVersion')]: gateway.swVersion,
          [L20NContext.getSync('hyperGateIseoSdkVersion')]: gateway.iseoSdkVersion,
          [L20NContext.getSync('lastConnectionDate')]: gateway.lastConnectionDate ? `${moment(gateway.lastConnectionDate).format('LLL')}` : '---',
          connectedLocks: gateway.smartLocks ? gateway.smartLocks.length : 0,
        });
      });
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const fileExtension = format.toLowerCase();
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = { Sheets: { gateways: ws }, SheetNames: ['gateways'] };
      const excelBuffer = XLSX.write(wb, { bookType: fileExtension, type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, `Gateways_Export.${fileExtension}`);
      return gateways;
    } catch (error) {
      let errorMessage = 'errorCreatingCSV';
      if (error.message === 'TOO_MANY_TASKS_SAME_TYPE') errorMessage = 'taskAlreadyExecuting';
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity={errorMessage} /></h6>),
        },
      }));
      throw new Error(error);
    }
  };
}


export function addSmartLockToGateway(gatewayId, lockId) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.addSmartLocksToGateway(gatewayId, lockId);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.code && error.response.data.code === 10503) {
        throw new Error('SMART_LOCK_ALREADY_PAIRED_WITH_GATEWAY_CODE');
      }
      throw error;
    }
  };
}

export function removeSmartLockFromGateway(gatewayId, smartlockId, force = false) {
  return async (dispatch, getState) => {
    try {
      const response = await GatewayAPI.removeSmartLockFromGateway(gatewayId, smartlockId, force);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function fetchGatewaysForSelector(searchText) {
  return async (dispatch, getState) => {
    try {
      const params = {
        page: 0,
        pageSize: 30,
        name: searchText,
      };
      const response = await GatewayAPI.fetchGateways(params);
      if (response.data && response.data.content) {
        //const formattedGateways = _.map(response.data.content, gateway => formatter.formatInputData(formatter.GATEWAY, { ...gateway }));
        return response.data.content;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error);
    }
  };
}

export function fetchGatewayConfiguration(gatewayId = null) {
  return async (dispatch, getState) => {
    const params = gatewayId ? { gatewayId } : {};
    try {
      const response = await GatewayAPI.fetchGatewayConfiguration(params);
      if (response.data) {
        const parsedData = JSON.parse(response.data.data);
        return { ...parsedData, type: response.data.type };
      }
      throw new Error();
    } catch (error) {
      throw error;
    }
  };
}

export function fetchHyperTouchDevices() {
  return async (dispatch) => {
    const response = await GatewayAPI.fetchHyperTouchDevices();
    const devices = response.data || [];
    dispatch({ type: SAVE_HYPERTOUCH_DEVICES, devices });
    return devices;
  };
}
